import { IState } from '..';
import { getPermissions } from '../auth';
import { IActiveUpload, IBlobFile, ICompletedUpload, IUploadFile } from './filesInterfaces';
import { createSelector } from '@reduxjs/toolkit';

export const getSalesDocuments = (state: IState): IBlobFile[] => {
  const permissions = getPermissions(state);
  const {
    files: { salesDocumentsUris, fileHash }
  } = state;
  let files: IBlobFile[] = [];

  if (permissions && permissions.sales) {
    const { salesDistricts } = permissions.sales;
    files = salesDocumentsUris.map(x => fileHash[x]).filter(x => canView(x, salesDistricts));
  }
  return files;
};

function canView(file: IBlobFile, salesDistricts: string[]): boolean {
  const salesDistKey = 'salesDistricts';
  let showFile = true;

  if (file.metadata && file.metadata[salesDistKey]) {
    const fileSalesDistricts = file.metadata[salesDistKey].split(',').filter(x => x.trim());
    if (fileSalesDistricts.length > 0) {
      showFile = fileSalesDistricts.some(x => salesDistricts.includes(x));
    }
  }

  return showFile;
}

export function getFiles(state: IState, container: string, folder: string): IBlobFile[] {
  const parentUri = state.config.blobStorage ? `${state.config.blobStorage.baseUrl}${container}/${folder}` : '';
  return Object.values(state.files.fileHash).filter(
    x => decodeURIComponent(x.parentUri as string) === decodeURIComponent(parentUri)
  );
}

export const getFileUploadActivity = createSelector(
  (state: IState) => state.files.uploads,
  (uploads): { active: IActiveUpload[]; failed: IUploadFile[]; completed: ICompletedUpload[] } => ({
    active: uploads.active.map<IActiveUpload>(x => ({
      name: x.file.name,
      progress: uploads.progress[x.url] ? uploads.progress[x.url] * 100 : 0,
      url: x.url
    })),
    completed: uploads.completed,
    failed: uploads.failed
  })
);
